<template>
  <svg width="23" height="23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.2938 7.82368c0-.518.434-.924.952-.924.532 0 .966.406.966.924s-.434.924-.966.924c-.518 0-.952-.406-.952-.924Zm.21 2.56202h1.498v6.44h-1.498v-6.44Z" fill="#000"/>
    <circle cx="11.75" cy="11.7443" r="10.25" stroke="#000" stroke-width="1.5"/>
  </svg>
</template>